"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NETWORK_CONFIG_MAP = void 0;
/**
 * Default configuration for all networks.
 */
exports.DEFAULT_NETWORK_CONFIG_MAP = {
    "mainnet-beta": {
        name: "Mainnet Beta",
        endpoint: "https://solana-api.projectserum.com/",
    },
    devnet: {
        name: "Devnet",
        endpoint: "https://api.devnet.solana.com/",
    },
    testnet: {
        name: "Testnet",
        endpoint: "https://api.testnet.solana.com/",
    },
    localnet: {
        name: "Localnet",
        endpoint: "http://127.0.0.1:8899",
    },
};
//# sourceMappingURL=constants.js.map